<div class="relative max-w-full w-[600px] h-full flex flex-col max-h-full overflow-hidden">
  <header class="p-6">
    <div class="flex items-start justify-between gap-2">
      <h2 class="w-full mb-0 text-xl font-medium text-center min-[492px]:pt-1">
        {{ data.name }}
      </h2>
      <button
        class="!border-solid !border-[1px] !border-black !border-opacity-10 !p-0 !w-[38px] !h-[38px]"
        type="button"
        mat-icon-button
        (click)="closeDialog()"
      >
        <span class="grid material-symbols-outlined light place-items-center">
          close
        </span>
      </button>
    </div>
  </header>
  <mat-dialog-content class="default !pt-2 !pb-8 !flex flex-col">
    <div class="flex flex-1 overflow-auto">
      <img [ngSrc]="data.link" [alt]="data.name" class="object-contain w-full max-w-full h-fit" width="200" height="200" priority />
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="!p-5 border-t !border-t-gray-200">
    <div class="flex flex-col items-stretch justify-start w-full gap-2 sm:flex-row">
      @if (data.subscription_button) {
        <button mat-flat-button color="primary" type="button" class="w-full !m-0" (click)="subscribe()">
          {{ data.subscription_button_text }}
        </button>
      } @else {
        <button mat-stroked-button type="button" class="w-full !m-0" (click)="closeDialog()">
          إغلاق
        </button>
      }
      @if (data.whatsapp_button) {
        <a href="https://wa.me/{{data.whatsapp_number}}?text={{data.whatsapp_message}}" target="_blank" dir="ltr" class="w-full">
          <button
            mat-flat-button
            class="max-w-full w-full !pr-6 !bg-[#22a200]"
            type="button"
            color="primary"
          >
            <span class="flex items-center justify-start gap-3">
              <img src="assets/icons/whatsapp-outline-white.svg" alt="واتس اب" class="w-6" />
              <span>
                {{ data.whatsapp_button_text }}
              </span>
            </span>
          </button>
        </a>
      }
    </div>
  </mat-dialog-actions>
</div>